import React from 'react'
import {Link} from 'react-router-dom'
import {Badge, Popover} from 'antd'

import {CloseIcon, PinIcon, TrolleyIcon, UserIcon} from 'components/CustomIcons'
import useCartContext from 'components/Cart/useCartContext'
import useUserContext from 'components/User/useUserContext'
import SideWelcomeBack from 'modules/UserProfile/SideWelcomeBack'

const AddressChanger = ({t}) => {
  const {delivery, openDeliveryModal} = useUserContext()

  return (
    <button className='nav-addressChanger' onClick={openDeliveryModal}>
      {delivery ? (
        <div>
          <span>{t('Delivery to')}</span>
          <span className='nav-addressSpan'><b>{delivery.contactName ?? delivery.zip}</b></span>
        </div>
      ) : (
        <div>
          <span>{t('Click here to set')}</span><br/>
          <span>{t('the delivery address')}</span>
        </div>
      )}
      <PinIcon/>
    </button>
  )
}

const UserPopover = ({history, t}) => {
  const {user} = useUserContext()

  return (
    user ? (
      <Popover
        overlayClassName='popover-welcomeBack'
        placement='bottomRight'
        content={<SideWelcomeBack t={t} history={history} user={user}/>}
      >
        <Link to='/profile'>
          <UserIcon className='nav-userPopoverOpener'/>
        </Link>
      </Popover>
    ) : (
      <Link to='/login'><UserIcon/></Link>
    )
  )
}

const BasketOpener = () => {
  const {cart, setCartVisible} = useCartContext()

  return (
    <button onClick={_ => setCartVisible(true)} className='nav-basketOpener'>
      <Badge count={Object.keys(cart.items).length}><TrolleyIcon/></Badge>
    </button>
  )
}


const ActionButtons = ({autocompleteSearching, closeSearchMain, history, t}) => (
  autocompleteSearching ? (
    <div>
      <button className='nav-close' onClick={_ => closeSearchMain()}>{t('CLOSE')}<CloseIcon/></button>
    </div>
  ) : (
    <div className='nav-links'>
      <AddressChanger t={t}/>
      <UserPopover t={t} history={history}/>
      <BasketOpener/>
    </div>
  )
)

export default ActionButtons
